/**
 * Finds an API from an app based on action's API reference.
 * Tries ID match first, falls back to type match for backward compatibility.
 *
 * @param {Object} app - The app object containing api array
 * @param {Object} action - The action object with api reference
 * @returns {Object} The matching API
 */
export const findApiByAction = (app, action) => {
  if (action?.api?.id) {
    const apiById = app?.api?.find?.((a) => a?.id === action?.api?.id);
    if (apiById) {
      return apiById;
    }
  }

  return app?.api?.find?.((a) => a?.type === action?.api?.type);
};
